import { Directive, Input, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';


@Directive({
  selector: '[hostMaxCharacters]'
})
export class MaxCharactersDirective {
  @Input('maxCharacters') maxCharacters = '30';
  @Output() ngModelChange = new EventEmitter();
  constructor(private el: ElementRef) { }

  @HostListener('blur', ['$event']) onBlur(event) {
    const maxlength = Number(this.maxCharacters);
    const input = this.el.nativeElement;
    let value = input.value;
    let strArr = value.split('');
    // len是已经输入的字符数
    const len = this.getStringLengthForCharacters(value);
    if (len > maxlength) {
      for (let i = strArr.length - 1; i >= 0; i--) {
        strArr = strArr.slice(0, i);
        value = strArr.join('');
        if (this.getStringLengthForCharacters(value) <= maxlength) {
          break;
        }
      }
    }
    // input.value = value;
    this.ngModelChange.emit(value);

  }

  getStringLengthForCharacters(val) {
    const str = val.toString();
    let bytesCount = 0;
    for (let i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i);
      // 这里是16进制表示，也可以用十进制
      if ((c > 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
        bytesCount = bytesCount + 1;
      } else {
        bytesCount = bytesCount + 2;
      }
    }
    return bytesCount;
  }
}
